import { __assign } from "tslib";
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { DropdownList } from '../dropdown-list/dropdown-list';
import { DropdownMenuTrigger } from './dropdown-menu-trigger';
import { noResultsItems } from '../dropdowns.helpers';
import classNames from 'classnames';
import styles from './dropdown-menu.module.css';
export var DropdownMenu = React.forwardRef(function (props, outerRef) {
    var 
    // html props
    id = props.id, name = props.name, disabled = props.disabled, multiple = props.multiple, 
    // custom props
    label = props.label, items = props.items, validation = props.validation, large = props.large, responsive = props.responsive, dialogContained = props.dialogContained;
    var cleansedProps = __assign(__assign({}, props), { 
        // html props
        disabled: disabled !== null && disabled !== void 0 ? disabled : false, multiple: multiple !== null && multiple !== void 0 ? multiple : false, 
        // custom props
        label: label, items: items, validation: validation, large: large });
    if (process.env.NODE_ENV !== 'production' && !multiple && !items.some(function (item) { return !!item.icon; })) {
        throw new Error('<DropdownMenu>: This Component should only be used for complex dropdowns that require icons or multiple selection. Otherwise, the <DropdownSelect> Component should be used which is built on built-in browser <select> and <option> functionality.');
    }
    var innerRef = useRef(null);
    useImperativeHandle(outerRef, function () { return innerRef.current; }, []);
    var _a = useState(items.length === 0 ? noResultsItems : items.map(function (item) { return (__assign({}, item)); })), currentItems = _a[0], setCurrentItems = _a[1];
    var _b = useState(currentItems.filter(function (item) { return item.selected; })), selectedItems = _b[0], setSelectedItems = _b[1];
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    /* Generate current and selected items whenever items changes */
    useEffect(function () {
        var nextItems = items.length === 0 ? noResultsItems : items.map(function (item) { return (__assign({}, item)); });
        setCurrentItems(nextItems);
        setSelectedItems(nextItems.filter(function (item) { return item.selected; }));
    }, [items]);
    // TODO: FieldController
    // useEffect(() => {
    //   if (!!props.value) return currentItems.find(item => item.value === props.value)?.onClick();
    //   if (!!props.defaultValue) return currentItems.find(item => item.value === props.defaultValue)?.onClick();
    // }, [props.defaultValue, props.value]);
    return (React.createElement("div", { className: classNames('fieldValidationWrapper', { responsive: responsive }), style: { zIndex: isOpen ? 99999 : 'auto' } },
        React.createElement(DropdownList, { items: currentItems, selectedItems: selectedItems, large: large, multiple: multiple, dialogContained: dialogContained }, function (_a) {
            var _b;
            var _c;
            var triggerRef = _a.triggerRef, open = _a.open, onOpenHandler = _a.onOpenHandler, onCloseHandler = _a.onCloseHandler, bottomQuadrant = _a.bottomQuadrant;
            return (React.createElement("div", { ref: triggerRef, className: classNames('inputWrapper', [styles.dropdownMenuWrapper], (_b = {
                        populated: !!selectedItems.length,
                        validation: (validation === null || validation === void 0 ? void 0 : validation.dirty) && (validation === null || validation === void 0 ? void 0 : validation.invalid),
                        disabled: disabled,
                        large: large,
                        responsive: responsive,
                        prefix: !open && !!((_c = selectedItems[0]) === null || _c === void 0 ? void 0 : _c.icon)
                    },
                    _b[styles.large] = large,
                    _b[styles.bottomQuadrant] = bottomQuadrant,
                    _b)) },
                React.createElement(DropdownMenuTrigger, __assign({}, cleansedProps, { selectedItems: selectedItems, bottomQuadrant: bottomQuadrant, open: open, onFocus: function () {
                        onOpenHandler();
                        setIsOpen(true);
                    }, onBlur: function () {
                        onCloseHandler();
                        setIsOpen(false);
                    } }))));
        }),
        !!validation && (React.createElement("div", { className: classNames('fieldValidation fieldErrorMessage', { invisible: !validation.dirty || !validation.invalid }) }, validation.message))));
});
DropdownMenu.displayName = 'DropdownMenu';
export default DropdownMenu;
